export default __webpack_public_path__ + "static/media/Hugo Paternostre .49677512.jpg";